import React from 'react';
import { IAuditoriaContaTransitoriaResultado } from '../interfaces/IAuditoriaContaTransitoria';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaContaTransitoriaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Conciliação de Contas Transitórias não é um tributo — é uma auditoria de
// encerramento/conciliação (sem cálculo de multa ou imposto na especificação original), que
// verifica mês a mês se contas transitórias/de passagem foram zeradas. Segue o mesmo padrão de
// seção própria já usado para os outros módulos de auditoria.
const AuditoriaResumoContaTransitoria: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.saldoNaoZerado?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Conciliação de Contas Transitórias</h3>
      <p className='text-muted'>
        Auditoria de encerramento — contas transitórias/de passagem devem ser zeradas em toda conciliação mensal (IN RFB
        nº 2.003/2021). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Saldo Remanescente</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_CONTA_TRANSITORIA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Conciliação de Contas Transitórias</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} ocorrência{totalOcorrencias === 1 ? '' : 's'} de saldo não zerado identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Sem multa/imposto — auditoria de conciliação/encerramento.</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoContaTransitoria;
